<template>
  <generic-preview :record="record" :hide-options="hideOptions" @edit="edit" @remove="remove">
    <preview-wrapper :record="record" :hide-options="hideOptions">
      <div class="grid grid-cols-2 gap-4">
        <div class="flex flex-col col-span-full gap-2">
          <span class="text-sm font-medium">Order/s</span>
          <span class="text-sm text-neutral-500">{{name}}</span>
        </div>
        <div class="flex flex-col col-span-full gap-2">
          <span class="text-sm font-medium">Diagnosis</span>
          <span class="text-sm text-neutral-500" v-if="diagnosisCode && diagnosisText">{{`(${diagnosisCode} - ${diagnosisText})`}}</span>
          <span class="text-sm text-neutral-500" v-else>-</span>
        </div>
        <div class="flex flex-col col-span-full gap-2">
          <span class="text-sm font-medium">Reason</span>
          <span class="text-sm text-neutral-500">{{reason || '-'}}</span>
        </div>
        <div class="flex flex-col col-span-full gap-2">
          <span class="text-sm font-medium">Notes</span>
          <span class="text-sm text-neutral-500">{{notes || '-'}}</span>
        </div>
      </div>
    </preview-wrapper>
  </generic-preview>
</template>

<script>
import { computed } from 'vue';
import { format } from 'date-fns';
import { useProcedureOrders } from './composables';
import GenericPreview from '@/components/medical-records/generic-preview.vue';
import PreviewWrapper from '@/components/medical-records/preview-wrapper.vue';

export default {
  components: {
    GenericPreview,
    PreviewWrapper,
  },
  props: {
    record: {
      type: Object,
      required: true,
      defafault: () => ({}),
    },
    hideOptions: {
      type: Boolean,
      default: false,
    },
    showRecordLabel: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const { remove: removeProcedureOrder } = useProcedureOrders();
    const name = computed(() => props.record.name);
    const diagnosisCode = computed(() => props.record.diagnosisCode);
    const diagnosisText = computed(() => props.record.diagnosisText);
    const reason = computed(() => props.record.reason);
    const notes = computed(() => props.record.notes);
    const createdAt = computed(() => format(new Date(props.record.createdAt), 'MM/dd/yyyy hh:mm a'));

    function edit () {
      emit('edit', props.record);
    }

    function remove () {
      removeProcedureOrder({ id: props.record.id });
    }

    return {
      createdAt,
      name,
      diagnosisCode,
      diagnosisText,
      reason,
      notes,
      edit,
      remove,
    };
  },
};
</script>
